import { makeStyles } from '@material-ui/styles';
import React, { useContext, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import logOutIcon from '../../../assets/images/Icon/logOutMobile.svg';
import MessagesContext from '../../../contexts/messagesContext';
import LanguageContext from '../../../contexts/languageContext';
import { Link } from 'react-router-dom';
import hamburger from '../../../assets/images/Icon/hamburger.svg';
import { useDispatch } from 'react-redux';
import listOfPatientsMobileIcon from '../../../assets/images/Icon/listOfPatientsMobile.svg';
import clinicMobileIcon from '../../../assets/images/Icon/clinicMobile.svg';
import profileMobileIcon from '../../../assets/images/Icon/profileMobile.svg';
import { deleteWorkspace, getRefreshToken } from '../../../utils/storage';
import { logout } from '../../../redux/User/UserAction';
import { useLocation } from 'react-router-dom';
import { Drawer as DrawerComponent } from '@material-ui/core';

const styles = makeStyles({
    sideWrapper: {
        width: '260px',
        direction: (props) => (props.rtl ? 'rtl' : 'ltr'),
        // height: '100vh',
        background: '#fff'
        // position: 'fixed',
        // top: '0',
        // right: 0,
        // bottom: '0',
        // zIndex: '10000000000',
        // transform: (props) => (props.open ? 'translateX(0px)' : 'translateX(260px)'),
        // transition: 'all 0.3s ease-in-out',
        // overflow: 'hidden',
        // opacity: (props) => (props.open ? '1' : '0')
    },
    sideContainer: {
        padding: '40px 24px'
    },
    column: {
        display: 'flex',
        flexDirection: 'column'
    },
    item: {
        marginBottom: '28px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',

        '& span': {
            margin: '0 12px'
        }
    },
    logo: {
        width: '24px',
        height: '24px'
    },
    backdrop: {
        zIndex: 1300,
        background: 'rgba(35, 39, 51, 0.32)'
    }
});
const Drawer = () => {
    const [open, setOpen] = useState(true);
    const { pathname } = useLocation();
    // const open = useSelector((state) => state.generalReducer.toggleSideBar);
    const dispatch = useDispatch();
    const { lang } = useContext(LanguageContext);
    const classes = styles({ open, rtl: lang === 'fa' });
    const { messages } = useContext(MessagesContext);
    const clinicId = pathname.split('/').filter((item) => item)[0];
    const handleClose = () => {
        setOpen(false);
    };
    const handleLogOut = () => {
        const refresh = getRefreshToken();
        dispatch(logout({ refresh }));
        deleteWorkspace();
        handleClose();
    };
    useEffect(() => {
        handleClose();
    }, [pathname]);
    const links = [
        {
            id: 1,
            title: messages.listOfPatients,
            path: 'patients',
            icon: listOfPatientsMobileIcon
        },
        {
            id: 2,
            title: messages.clinic,
            path: 'select-clinic',
            icon: clinicMobileIcon
        },
        {
            id: 3,
            title: messages.profile,
            path: 'profile',
            icon: profileMobileIcon
        }
    ];

    return (
        <>
            <>
                <img src={hamburger} alt="hamburger icon" onClick={() => setOpen(true)} />

                <DrawerComponent
                    anchor={lang === 'fa' ? 'right' : 'left'}
                    open={open}
                    onClose={handleClose}
                >
                    <div className={classes.sideWrapper}>
                        <div className={classes.sideContainer}>
                            <div className={classes.column}>
                                {links?.map((item) => (
                                    <Link
                                        className={classes.item}
                                        key={item.id}
                                        to={`/${clinicId}/${item.path}`}
                                        onClick={handleClose}
                                    >
                                        <img src={item.icon} className={classes.logo} />
                                        <span>{item.title}</span>
                                    </Link>
                                ))}
                                <div className={classes.item} onClick={handleLogOut}>
                                    <img src={logOutIcon} className={classes.logo} />
                                    <span>{messages.logout}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </DrawerComponent>
            </>
        </>
    );
};
Drawer.propTypes = {
    handleLogOut: PropTypes.func,
    links: PropTypes.array
};

export default Drawer;
